import { getFscSelectedPackId, FSC_INCLUDED_PACK_ID, FSC_OTHER_PACK_ID, FSC_INCLUDED_CREDIT_PACK_SELECTION, isPresetCreditPackSize } from './fscCreditPacksHelpers';
export function serializeFscUrlProduct(product) {
  const {
    productApiName,
    incrementalQuantity,
    skuQuantity
  } = product;
  if (incrementalQuantity !== undefined) {
    return `${productApiName}_${incrementalQuantity}_inc`;
  }
  if (skuQuantity !== undefined) {
    return `${productApiName}_${skuQuantity}`;
  }
  return null;
}
export function parseFscUrlProduct(productStr) {
  if (!productStr) return null;
  const isIncremental = productStr.endsWith('_inc');
  const cleaned = isIncremental ? productStr.slice(0, -4) : productStr;
  const parts = cleaned.split('_');
  const lastPart = parts[parts.length - 1];
  const quantityValue = Number(lastPart);
  if (!isNaN(quantityValue)) {
    const productApiName = parts.slice(0, -1).join('_');
    if (!productApiName) return null;
    return Object.assign({
      productApiName
    }, isIncremental ? {
      incrementalQuantity: quantityValue
    } : {
      skuQuantity: quantityValue
    });
  }
  return {
    productApiName: cleaned
  };
}

/* FE-only URL marker recording which tile the shopper picked. It is written
 * one-way from the authoritative local selection; presets and "Other" otherwise
 * serialize identically (committed × N), so the marker is what lets a reload
 * rebuild the exact tile. An absent marker means the included baseline. */
export const FSC_AGENT_PACK_PARAM = 'agentPack';

/** The `agentPack` marker for a selection, or null for the included baseline
 * (which is the absence of the param). */
const getFscAgentPackUrlMarker = selection => {
  const id = getFscSelectedPackId(selection);
  return id === FSC_INCLUDED_PACK_ID ? null : id;
};
export const setFscAgentPackMarker = (params, selection) => {
  const marker = getFscAgentPackUrlMarker(selection);
  params.delete(FSC_AGENT_PACK_PARAM);
  if (marker) {
    params.set(FSC_AGENT_PACK_PARAM, marker);
  }
};

/**
 * Reconstructs the pack selection from the cart's committed-credit quantity plus
 * the FE `agentPack` marker. The marker (our lossless mirror of the local selection)
 * restores the exact tile and the committed-credit line supplies the quantity.
 * A marker-less URL (an external deep-link) is best-effort: any committed
 * credits resolve to the custom "Other" amount, else the included baseline.
 */
export const getFscPackSelectionFromUrl = (committedQuantity, packMarker) => {
  if (packMarker && isPresetCreditPackSize(packMarker)) {
    return {
      kind: 'preset',
      creditPackSize: packMarker,
      committedSkuQuantity: committedQuantity
    };
  }
  if (packMarker === FSC_OTHER_PACK_ID) {
    return {
      kind: 'custom',
      committedSkuQuantity: committedQuantity
    };
  }
  return committedQuantity > 0 ? {
    kind: 'custom',
    committedSkuQuantity: committedQuantity
  } : FSC_INCLUDED_CREDIT_PACK_SELECTION;
};